const $win = $(window);

function animatedClass(ele, deviate){
  $(ele).each(function() {
    const $this = $(this);
    const winScroll = $(window).scrollTop(),
      expOff = $this.offset().top - $win.height()/deviate;

    if (winScroll > expOff) {
      $this.addClass('animated');
    }
    else{
      $this.removeClass('animated');
    }
  })
}

$win.on('scroll load', function() {
  animatedClass('.animation', 1.3);  
})



// WEBPACK FOOTER //
// ../assets/js/animate.js